import { useMemo } from 'react'
import { generatePath, Redirect, Route } from 'react-router-dom'
import Content from 'app/Content'
import {
  reportsCampaignsPath,
  reportsDashboardPath,
  reportsDataSearchPath,
  reportsInsightsPath,
  reportsJaqiAiPath,
  reportsPath,
  reportsPerformancePath,
  reportsPersonalizationPath,
} from 'app/navigation/paths'
import CustomSwitch from 'app/router/Switch'
import { useFlags } from 'launchdarkly-react-client-sdk'

import { useAppSelector } from 'common/hooks/redux'
import Personalization from 'features/personalization'

import Dashboard from './dashboard/Dashboard'
import Insights from './insights/Insights'
import Performance from './performance/Performance'

const Reports = () => {
  const {
    campaignThoughtspotSnowflake,
    showBothReviewAndManage,
    showDataSearch,
    showJaqi,
  } = useFlags()

  const accountId = useAppSelector((state) => state.authStates.accountId)

  const performanceSubroute = generatePath(reportsPerformancePath, {
    accountId,
  })
  const insightsSubroute = generatePath(reportsInsightsPath, {
    accountId,
  })
  const personalizationSubroute = generatePath(reportsPersonalizationPath, {
    accountId,
  })

  const reportingPaths = useMemo(() => {
    const paths = [reportsDashboardPath, reportsCampaignsPath]
    if (campaignThoughtspotSnowflake) {
      if (showDataSearch) {
        paths.push(reportsDataSearchPath)
      }
      if (showJaqi) {
        paths.push(reportsJaqiAiPath)
      }
    }
    return paths
  }, [campaignThoughtspotSnowflake, showDataSearch, showJaqi])

  return (
    <CustomSwitch>
      <Route path={reportsPerformancePath}>
        <Content>
          <Performance />
        </Content>
      </Route>
      <Route path={reportsInsightsPath}>
        <Content>
          <Insights />
        </Content>
      </Route>
      <Route path={reportsPersonalizationPath}>
        <Personalization />
      </Route>

      {campaignThoughtspotSnowflake ||
      (showBothReviewAndManage && !campaignThoughtspotSnowflake) ? (
        <Route path={reportingPaths}>
          <Dashboard />
        </Route>
      ) : null}

      <Redirect exact from={reportsPath} to={performanceSubroute} />
      <Redirect exact from="/reports" to={performanceSubroute} />
      <Redirect exact from="/reports/performance" to={performanceSubroute} />
      <Redirect exact from="/reports/insights" to={insightsSubroute} />
      <Redirect
        exact
        from="/reports/personalization"
        to={personalizationSubroute}
      />
    </CustomSwitch>
  )
}

export default Reports
